interface Props {
    className?: string;
}

export function PlusIcon({ className }: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 25 24" fill="none">
            <path
                d="M12.1094 10.6094V4.0625H12.8906V10.6094H12.1094ZM12.1094 11.6094H12.8906V12.3906H12.1094V11.6094ZM13.8906 12.3906V11.6094H20.0625V12.3906H13.8906ZM12.1094 13.3906H12.8906V19.9375H12.1094V13.3906ZM11.1094 11.6094V12.3906H4.9375V11.6094H11.1094Z"
                fill="currentColor"
                stroke="currentColor"
            />
        </svg>
    );
}
